export type GetTokensRequest = {
  environmentName?: string;
} | void;

export type TokenResponse = {
  tokens:
    | {
        token_id: string;
        scope: string;
        expires_in: number;
        is_active: boolean;
        subject: string;
        issued_at: number;
        expiry: number;
        issuer: string;
        description?: string;
      }[]
    | null;
};

export type GenerateTokenRequest = {
  username: string;
  scope: string;
  description: string;
  expires_in: number;
  refreshable?: boolean;
  include_reference_token?: boolean;
  environment?: string;
};

export type GenerateTokenResponse = {
  token_id: string;
  access_token: string;
  expires_in: number;
  scope: string;
  token_type: string;
  username: string;
  reference_token: string;
};

export type Token = {
  tokenId: string;
  scope: Permission;
  expiresIn: number;
  isActive: boolean;
  subject: string;
  issuedAt: Date;
  expiry: Date;
  issuer: string;
  description: string;
};

export type GeneratedToken = {
  tokenId: string;
  accessToken: string;
  expiresIn: number;
  scope: string;
  tokenType: string;
  username: string;
  referenceToken: string;
};

export const Permission = {
  READ: 'viewers',
  READ_WRITE: 'developers',
} as const;
export type Permission = (typeof Permission)[keyof typeof Permission];
